import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";

// 代行者参照API
// API仕様書_代行者
import {
  IAPI_AGE002_Request,
  IAPI_AGE002_Response,
} from "../../../type/apiType";

// 代行者更新API
// API仕様書_代行者
import {
  IAPI_AGE003_Request,
  IAPI_AGE003_Response,
} from "../../../type/apiType";

// 代行者参照API
const httpAPI_AGE002 = async (
  param: IAPI_AGE002_Request
): Promise<IAPI_AGE002_Response> => {
  let res = await http.post(ApiUrl.API_AGE002, {
    ...param,
  });
  return res.data;
};

// 代行者更新API
const httpAPI_AGE003 = async (
  param: IAPI_AGE003_Request
): Promise<IAPI_AGE003_Response> => {
  let res = await http.post(ApiUrl.API_AGE003, {
    ...param,
  });
  return res.data;
};

export { httpAPI_AGE002, httpAPI_AGE003 };
